module.exports = __webpack_public_path__ + "static/img/cztqrcode.82d43c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cztqrcode.png
// module id = 57
// module chunks = 0